import { ApiCatch } from "@/utils/decorators";
import { Api } from "../api.service";

export class HealthService {
  @ApiCatch
  static async getSystemStatus() {
    const response = await Api.get("health/systemStatus");
    return response;
  }
}
